<template>
  <div class="">

    <Tabs type="card" v-model="current">
      <TabPane label="基础信息" name="houseTypeBaseInfo">
        <keep-alive>
          <house-type-base-info :houseTypeData="houseTypeDetailInfoVo"></house-type-base-info>
        </keep-alive>
      </TabPane>
      <TabPane label="图片配置" name="picInfo">
        <keep-alive>
          <pic-info :list="topPicList" @showimg="showImg"></pic-info>
        </keep-alive>
      </TabPane>
      <TabPane label="房型配置" name="houseTypeConfigInfo">
        <keep-alive>
          <house-type-config-info :houseTypeConfigs="houseTypeConfigs"></house-type-config-info>
        </keep-alive>
      </TabPane>
      <TabPane label="可租房间" name="houseList">
        <keep-alive>
          <house-list></house-list>
        </keep-alive>
      </TabPane>
    </Tabs>
    <img-show :n="imgN" :src="imgSrc"></img-show>

  </div>
</template>

<script>
  import {getHouseTypeDetail} from "../../../api/houseType";
  import TableList from "components/TableList/index";
  import ImgShow from 'components/ImgShow/index';
  import HouseTypeBaseInfo from './components/HouseTypeBaseInfo';
  import PicInfo from './components/PicInfo';
  import HouseTypeConfigInfo from './components/HouseTypeConfigInfo';
  import HouseList from './components/HouseList';
  export default {
    components: {
      TableList,
      ImgShow,
      HouseTypeBaseInfo,
      HouseTypeConfigInfo,
      PicInfo,
      HouseList,
    },
    data() {
      return {
        houseTypeFid: '',
        current: 'houseTypeBaseInfo',
        imgN: 0,
        imgSrc: '',
        topPicList:[],
        houseTypeDetailInfoVo:{},
        houseTypeConfigs:[]
      }
    },
    methods: {
      showImg(data) {
        this.imgSrc = data
        this.imgN++

      },
      getHouseTypeDetail(){
        if (!this.houseTypeFid) {
          return
        }
        let params = {
          houseTypeFid: this.houseTypeFid
        }
        getHouseTypeDetail(params).then(res=>{
          if(!res.data || res.data.length===0){
            return
          }
          this.topPicList = res.data.topPicList;
          this.houseTypeDetailInfoVo = res.data;
          this.houseTypeConfigs = res.data.houseTypeConfigs;
        })
      }
    },
    computed: {},
    created() {
      this.houseTypeFid = this.$route.query.houseTypeFid
      this.getHouseTypeDetail()
    }
  }
</script>

<style scoped>

  .info-wrapper {
    display: flex;
  }

  .content {
    padding: 30px 20px;
    box-sizing: border-box;
  }
</style>
